// You can write more code here

import { getTrialDaysRemaining } from '@/common/utils/license';
import { getStudent } from '@/game/GameComponents/PhaserGame/GameInstance';

/* START OF COMPILED CODE */

/* START-USER-IMPORTS */
import api from '@/db/apiClient';
/* END-USER-IMPORTS */

export default class TrialTimer extends Phaser.GameObjects.Container {
  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 0, y ?? 0);

    // fadeOut
    const fadeOut = scene.add.nineslice(
      -22,
      16,
      'fadeOut',
      undefined,
      192,
      8,
      3,
      1,
      1,
      1,
    );
    fadeOut.scaleY = 4;
    fadeOut.setOrigin(1, 0.5);
    fadeOut.alpha = 0.4;
    fadeOut.tint = 3023407;
    this.add(fadeOut);

    // timerIcon
    const timerIcon = scene.add.image(-8, 0, 'clock');
    timerIcon.scaleX = 2;
    timerIcon.scaleY = 2;
    timerIcon.setOrigin(1, 0);
    this.add(timerIcon);

    // timeRemainingText
    const timeRemainingText = scene.add.bitmapText(
      -44,
      16,
      'Aronui',
      '30 Days Remaining for Trial',
    );
    timeRemainingText.setOrigin(1, 0.5);
    timeRemainingText.tintTopLeft = 15130076;
    timeRemainingText.tintTopRight = 15130076;
    timeRemainingText.tintBottomLeft = 15130076;
    timeRemainingText.tintBottomRight = 15130076;
    timeRemainingText.text = '30 Days Remaining for Trial';
    timeRemainingText.fontSize = -12;
    this.add(timeRemainingText);

    this.timeRemainingText = timeRemainingText;

    /* START-USER-CTR-CODE */
    this.scene.events.on('awake', this.update, this);
    /* END-USER-CTR-CODE */
  }

  private timeRemainingText: Phaser.GameObjects.BitmapText;

  /* START-USER-CODE */

  async update() {
    const student = getStudent();
    if (!Object.keys(student).length) {
      this.setVisible(false);
      return;
    }

    const organisation = await api.asStudent.getOrganisation(
      student.organisationId,
    );
    if (!organisation) {
      this.setVisible(false);
      return;
    }

    const trialEndDate = organisation.license.trialEndDate;
    const trialDaysRemaining = getTrialDaysRemaining(trialEndDate);
    const suffix = trialDaysRemaining === 1 ? '' : 's';
    this.timeRemainingText.text = `${trialDaysRemaining} Day${suffix} Remaining for Trial.`;
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
